export const landingPageSlug = "/bp"
